/**
 * Global Animation Handler for Goatfather Theme
 * Handles .reveal elements and Shopify Editor events.
 */

const GFAnimations = {
    observer: null,

    init() {
        // Basic Observer
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    this.observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        // Bind
        this.bindEvents();
        this.refresh();
    },

    bindEvents() {
        // Listen for Shopify Theme Editor Events
        document.addEventListener('shopify:section:load', (e) => this.handleEditorEvent(e.target));
        document.addEventListener('shopify:section:select', (e) => this.handleEditorEvent(e.target));
        document.addEventListener('shopify:section:reorder', () => this.refresh());
    },

    handleEditorEvent(target) {
        if (!target) return;
        // In editor, we want to show things immediately so they don't look broken
        this.refresh(target, true);
    },

    refresh(root = document, forceVisible = false) {
        // 1. Find all .reveal elements inside root
        if (!root || !root.querySelectorAll) return; // Safety check
        const elements = root.querySelectorAll('.reveal');

        // 2. Also check if root itself is .reveal
        const targets = Array.from(elements);
        if (root.classList && root.classList.contains('reveal')) {
            targets.push(root);
        }

        const isDesignMode = forceVisible ||
            (window.Shopify && window.Shopify.designMode) ||
            document.documentElement.classList.contains('shopify-design-mode');

        targets.forEach(el => {
            if (el.classList.contains('active')) return;

            // Force visible if requested (Editor)
            if (isDesignMode) {
                el.classList.add('active');
                el.style.opacity = '1';
                el.style.transform = 'none';
                el.style.transition = 'none'; // Disable transition for instant feedback
            } else {
                this.observer.observe(el);
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    GFAnimations.init();
});

// Ensure global availability
window.GFAnimations = GFAnimations;
